import React, { useState } from 'react';
import styled from 'styled-components';
import { Divider } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const FooterContainer = styled.footer`
  width: 100%;
  padding: 20px 0;
  margin-top: 40px;
  text-align: center;
  border-top: 1px solid #e8e8e8;

  a {
    color: #6d7582;
    font-size: 14px;
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: #1890ff;
    }

    strong {
      font-weight: 700;
    }
  }

  span {
    color: #6d7582;
    font-size: 14px;
    text-decoration: none;
    transition: color 0.3s;
  }

  .ant-divider {
    margin: 0 12px;
    background-color: #d9d9d9;
  }
`;

const FooterCertTooltipContent = styled.div`
  position: absolute;
  bottom: 33px;
  left: -20%;
  width: 250px;
  background: #ffffff;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  border: #7f7f7f solid 1px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-contents: flex-start;
  align-items: start;
  font-size: 13px;
  font-weight: 400;
  text-align: start;
  :after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 12px 10px 0;
    border-color: #ffffff transparent;
    display: block;
    width: 0;
    z-index: 1;
    bottom: -12px;
    left: 12px;
  }
  :before {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 12px 10px 0;
    border-color: #7f7f7f transparent;
    display: block;
    width: 0;
    z-index: 1;
    bottom: -13px;
    left: 12px;
  }
`;

const Footer = () => {
  const [hover, setHover] = useState<boolean>(false);

  return (
    <FooterContainer>
      <ExclamationCircleOutlined
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
        style={{ marginRight: '3px' }}
      />
      <span
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
        style={{ position: 'relative' }}
      >
        정보보호관리체계인증(ISMS)
        {hover && (
          <FooterCertTooltipContent>
            <p style={{ marginBottom: 0 }}>
              <strong>인증범위:</strong> 기업 복지 서비스 플랫폼(식권대장)(정보통신망법 제47조의7에 따른 인증의 특례)
            </p>
            <p style={{ marginBottom: 0 }}>
              <strong>유효기간:</strong> 2026.03.18 ~ 2029.03.17
            </p>
          </FooterCertTooltipContent>
        )}
      </span>
      <Divider type="vertical" />

      <a href="https://sikdae.com/privacy" target="_blank" rel="noopener noreferrer">
        <strong>개인정보 처리방침</strong>
      </a>
      <Divider type="vertical" />
      <a href="https://sikdae.com/term" target="_blank" rel="noopener noreferrer">
        이용약관
      </a>
    </FooterContainer>
  );
};

export default Footer;
